import React, { useState, useEffect, useContext, useRef } from 'react';
import AgeVerification from '../../../pages/AgeVerification';
import apiService from '../../../utils/apiService';
import InProgressScreen from '../status-screens/InProgressScreen';
import SuccessScreen from '../status-screens/SuccessScreen';
import YoungScreen from '../status-screens/YoungScreen';
import NotRealScreen from '../status-screens/NotRealScreen';
import ErrorScreen from '../status-screens/ErrorScreen';
import { getImageFromS3 } from '../../../imageService';
import styles from './index.module.scss';
import { DataLayerEventContext } from '../../../contexts/dataLayerEventContext';

const SKIP_REGISTRATION_CAMPAIGNS = [
  '25UA-MPM-B',
  '25UA-MPM-R',
  '24UA-MPM-PR',
  '23UA-LM-6'
];

const FaceCaptureScreen = ({ setScreenNumber, onSuccessFlow = undefined }) => {
  const { sendEvent } = useContext(DataLayerEventContext);
  const utm_campaign = sessionStorage.getItem('utm_campaign');
  const isSkipRegistration = SKIP_REGISTRATION_CAMPAIGNS.includes(utm_campaign);
  const [isSuccess, setIsSuccess] = useState(false);
  const [isError, setIsError] = useState(false);
  const [isYoung, setIsYoung] = useState(false);
  const [isNotReal, setIsNotReal] = useState(false);
  const [isInProgress, setInProgress] = useState(false);
  const [showPreCameraModal, setShowPreCameraModal] = useState(true);
  const isMountedRef = useRef(true);
  const timersRef = useRef([]);

  useEffect(() => {
    if (showPreCameraModal) {
      const timer = setTimeout(() => {
        setShowPreCameraModal(false);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [showPreCameraModal]);

  const handleSignatureReceived = async (data) => {
    if (!isMountedRef.current) return;

    setInProgress(true);

    try {
      const payload = {
        signature: data?.signature,
        image: data?.image,
        version: data?.version,
        token: data?.token,
        verification: data?.verification
      };

      const response = await apiService.post(
        'api/cda/users/age/verification/validate',
        {
          data: payload,
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );

      const timer1 = setTimeout(() => {
        if (!isMountedRef.current) return;

        setInProgress(false);

        if (
          response?.data?.data?.toLowerCase() === 'verified' &&
          response?.data?.success
        ) {
          sendEvent('verification_success');
          sessionStorage.setItem('verification_success', 'true');
          setIsSuccess(true);

          const timer2 = setTimeout(() => {
            if (!isMountedRef.current) return;

            setIsSuccess(false);

            if (isSkipRegistration) {
              onSuccessFlow
                ? onSuccessFlow()
                : (window.location.href = `https://yourjourney.com.ua/${utm_campaign}`);
            } else {
              onSuccessFlow ? onSuccessFlow() : setScreenNumber(8);
            }
          }, 2000);
          timersRef.current.push(timer2);
        } else if (!response?.data?.success) {
          sendEvent('age_verification_fail');
          setIsNotReal(true);
          const timer4 = setTimeout(() => {
            if (!isMountedRef.current) return;

            setIsNotReal(false);
            setScreenNumber(7);
          }, 2000);
          timersRef.current.push(timer4);
        } else {
          sendEvent('age_verification_fail');
          setScreenNumber(7);
        }
      }, 2000);
      timersRef.current.push(timer1);
    } catch (e) {
      const timer5 = setTimeout(() => {
        if (!isMountedRef.current) return;

        sendEvent('age_verification_fail');
        setInProgress(false);
        setIsError(true);
        const timer6 = setTimeout(() => {
          if (!isMountedRef.current) return;

          setIsError(false);
          setScreenNumber(7);
        }, 2000);
        timersRef.current.push(timer6);
      }, 2000);
      timersRef.current.push(timer5);
    }
  };

  if (isInProgress) {
    return <InProgressScreen />;
  }

  if (isSuccess) {
    return <SuccessScreen />;
  }

  if (isYoung) {
    return <YoungScreen />;
  }

  if (isNotReal) {
    return <NotRealScreen />;
  }

  if (isError) {
    return <ErrorScreen />;
  }

  if (showPreCameraModal) {
    return (
      <div
        className={styles.modal}
        style={{
          backgroundImage: `url("${getImageFromS3(
            'images/ua-brand/before-camera-modal-bg.png'
          )}")`
        }}
      >
        <img
          src={getImageFromS3('images/ua-brand/before-camera-modal.png')}
          alt="modal-image"
          className={styles.modalImage}
        />
      </div>
    );
  }

  return (
    <AgeVerification
      onSignatureReceived={handleSignatureReceived}
      onError={() => setScreenNumber(7)}
    />
  );
};

export default FaceCaptureScreen;
